import React from 'react';
import { Button } from 'react-bootstrap';
import { FaCartPlus } from 'react-icons/fa';
import './index.scss';

function Card(props) {
    return(
        <div class="col mb-4">
            <div class="card h-100">
                <img src={props.data.card.imageurl} class="card-img-top" style={{width: "15rem"}}alt="..."/>
                <div class="card-body">
                    <h5 class="card-title">{props.data.card.nama}</h5>
                    <p class="card-text">{props.data.card.deskripsi}</p>
                    <Button className="shadow w-50 btn btn-primary mr-5">Beli</Button>
                    <Button className="shadow btn btn-secondary"><FaCartPlus className="icon cart"/></Button>
                </div>
            </div>
        </div>
    )
}

export default Card;